import { withStyles } from "@mui/styles"
import { useEffect, useState } from "react"
import Dropzone from "react-dropzone"
import { FormattedMessage, injectIntl } from "react-intl"
import { Styles } from "src/styles/material-styles"
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Avatar, Button, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material"
import { PapiroConsole } from "src/utils/papiroConsole"
import ApiRag from "src/services/apiRag"
import Api from "src/services/api"
import { Delete, Description, Image } from "@mui/icons-material"
import FileCard from "./filecard"
import * as LLMDocumentService from 'src/services/llmdocument.service';

const LlmDocuments = (props) => {
    const { classes, intl, llm, onShowNotification, onLoading, hirerid } = props

    const [files, setFiles] = useState([])
    const [itens, setItens] = useState([])

    useEffect(() => {
        getItems()
    }, [])

    const removeFile = (file) => {
        let array = [...files]
        let index = array.indexOf(file)
        if (index !== -1) {
            array.splice(index, 1)
            setFiles(array)
        }
    }

    const removeItem = (file) => {
        setItens(itens.filter(item => item.id !== file.id))
    }

    const getItems = async () => {
        onLoading(true)
        const apiurl = Api.apiurlbase().replace("https", '').replace("http", '').replace("://", "").replace('/', '')
        let data = new FormData()
        data.append('hirerid', hirerid)
        data.append('llmId', llm.id)
        data.append('urlapi', apiurl)

        await ApiRag.post(`/rag/document/list`, data)
            .then((response) => {
                if (response)
                    setItens(response.data?.data)
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.getting.files" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const addFiles = async () => {
        
        if (files.length === 0) {
            onShowNotification(intl.formatMessage({ id: "attach.your.files" }), 'warning')
            return
        }

        onLoading(true)
        const apiurl = Api.apiurlbase().replace("https", '').replace("http", '').replace("://", "").replace('/', '')
        let data = new FormData()
        data.append('hirerid', hirerid)
        data.append('llmId', llm.id)
        data.append('urlapi', apiurl)
        files.forEach((file, index) => {
            data.append('files', file)
        })

        await ApiRag.post(`/rag/document/upload`, data)
            .then((response) => {
                onShowNotification(intl.formatMessage({ id: "add.success" }), 'success')
                setFiles([])

                if (response)
                    setItens([...itens, ...response.data?.data])
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.uploading.files" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const getFile = async (file) => {
        onLoading(true)

        let url = await LLMDocumentService.getFileByBucketKey(hirerid, file.bucketkey)
        if (url && url.data && url.data.data && url.data.success) {
            onLoading(false)
            window.open(`${url.data.data}`, '_blank')
        } else {
            onLoading(false)
            onShowNotification(intl.formatMessage({ id: "file.not.found" }), 'error')
        }
    }

    const onDelete = async (file) => {
        onLoading(true)
        
        const apiurl = Api.apiurlbase().replace("https", '').replace("http", '').replace("://", "").replace('/', '')
        let data = new FormData()
        data.append('hirerid', hirerid)
        data.append('id', file.id)
        data.append('urlapi', apiurl)

        await ApiRag.post(`/rag/document/delete`, data)
            .then((response) => {
                onShowNotification(intl.formatMessage({ id: "delete.sucess" }), 'success')
                if (response)
                    removeItem(file)
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.deleting.files" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    return (
        <div>
            <section style={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}>
                <div className={classes.dropzoneArea} style={{ minHeight: '70px', marginTop: '5px ' }}>
                    <Dropzone onDrop={acceptedFiles => {
                        setFiles([...acceptedFiles, ...files])
                    }}>
                        {({ getRootProps, getInputProps, acceptedFiles }) => (
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <AttachFileIcon />
                                <Typography component="span" fontWeight="bold" fontSize={16} color="gray">
                                    <FormattedMessage id="drag.and.drop.files" />
                                </Typography>
                            </div>
                        )}
                    </Dropzone>
                    {files.map(file => {
                        return (
                            <div className={classes.dropzoneItem} key={file.name}>
                                {file.name}
                                <DeleteForeverIcon className={classes.deleteItem} onClick={() => { removeFile(file) }} />
                            </div>
                        )
                    })}
                </div>
            </section>
            <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                <Grid item xs={12} sm={4} md={2} justify="flex-end" >
                    <Button
                        fullWidth
                        variant='contained'
                        color='primary'
                        className={classes.submit}
                        onClick={addFiles}
                    >
                        <FormattedMessage id="add" />
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '20px' }}>
                <Grid container spacing={2} direction='row' >
                    {itens.map((item, index) => (
                        <FileCard key={index} file={item} onOpenFile={getFile} onDelete={onDelete} intl={intl} />
                    ))}
                </Grid>
            </Grid>
        </div>
    )
}

export default injectIntl(withStyles(Styles)(LlmDocuments))